



























































































































































import { Component, Vue } from "vue-property-decorator";
import { client } from "../../../api/request";
import Decimal from "decimal.js";
// 共通コンポーネント
import VToolbar from "../../common/components/VToolbar.vue";
import SubmitButton from "@/components/SubmitButton.vue";
import SelectOption from "@/common/ui/presenters/select-option";
// 見積テンプレート
import { EstimateTemplate } from "@/api/estimate-templates-api";
// 見積書項目
import EstimateItem from "../components/EstimateItem.vue";
import EstimateHeader from "../components/EstimateHeader.vue";
// 見積書項目 データ
import Estimate from "@/usecases/accounting/estimate";
import EstimateService from "@/usecases/accounting/estimate-service";
import EstimateApi from "../../../api/accounting/estimate-api";
import {
  ExpenseCategory,
  getExpenseCategories
} from "@/api/cost/expense-categories-api";
import UnitApi from "../../../accounting/api/unit-api";
import UnitOption from "../presenters/unit-option";

import ProfitRateModal from "@/components/ProfitRateModal.vue";
import { estimateFromProfitRate } from "@/models/estimate-from-profit-rate";

// 行操作
import MoveEvent from "../presenters/move-event";

const estimateApi = new EstimateApi(client);
const unitApi = new UnitApi(client);
const service = new EstimateService(estimateApi);

@Component({
  components: {
    VToolbar,
    SubmitButton,
    EstimateItem,
    EstimateHeader,
    ProfitRateModal
  }
})
export default class EstimateTemplateEditPage extends Vue {
  calcFromProfitRateModalOpen = false;
  calcInvoiceFromProfitRateModalOpen = false;

  estimate = new Estimate();
  unitOptions: SelectOption[] = [];
  expenseCategories: ExpenseCategory[] = [];
  estimateTemplate: EstimateTemplate | null = null;
  templateProfitRate = { profitRate: "", lossRate: "" };

  saving = false;
  status = "";

  get fields(): string[] {
    return [
      "品目",
      "経費カテゴリ",
      "数量",
      "単位",
      "単価",
      "金額",
      "発注単価",
      "発注金額",
      "利益率",
      "備考"
    ];
  }
  get expenseCategoryOptions() {
    return this.expenseCategories.map(category => ({
      value: category.id,
      text: category.name
    }));
  }
  get childListClassName() {
    return {
      expanded: this.editing
    };
  }

  //ロード時の動作
  protected created() {
    this.initUnitList();
    this.initExpenseCategories();
  }

  // 一覧画面(親)に移動
  goListPage() {
    this.$router.push({ path: "/admin/estimate-template" });
  }

  private async initUnitList() {
    this.unitOptions = [
      { text: "", value: "" },
      ...(await unitApi.findAll()).map(UnitOption)
    ];
  }

  async initExpenseCategories() {
    this.expenseCategories = [
      { id: "", name: "", important: false },
      ...(await getExpenseCategories())
    ];
  }

  // 見積項目: 行操作
  private editing = false;
  move(e: MoveEvent) {
    // 子がいる親を子にすることはできない
    const from = e.from.dataset.type;
    const to = e.to.dataset.type;
    const children = e.draggedContext.element.items.length;
    return !(from === "parents" && to === "children" && children > 0);
  }
  dragstart() {
    this.editing = true;
  }
  dragend() {
    this.editing = false;
    this.calculateTotal();
  }
  async addNewItem() {
    await service.addNewItem(this.estimate);
  }
  async addNewItems(items: number) {
    for (let i = 0; i < items; i++) {
      await service.addNewItem(this.estimate);
    }
  }
  async addNewItemAfter(itemId: string) {
    await service.addNewItemAfter(this.estimate, itemId);
  }
  async removeItem(itemId: string) {
    this.estimate = await service.removeItem(this.estimate, itemId);
  }
  async removeAllItems() {
    if (!confirm("全ての項目を削除します。よろしいですか？")) return;
    this.estimate = await service.removeAllItems(this.estimate);
  }

  // 合計額計算
  async calculateTotal() {
    this.estimate = await service.calculateTotal(this.estimate);
  }
  // 発注額計算

  async calculateInvoice(profitRate: number) {
    if (!confirm("発注額を上書きします。本当に実行してもよろしいですか？")) {
      return;
    }
    this.estimate.lossRate = new Decimal(1)
      .minus(profitRate)
      .mul(100)
      .toNumber();
    this.estimate = await service.calculateInvoice(this.estimate);
  }
  // 見積額計算
  async calculateFromProfitRate(profitRate: number) {
    if (!confirm("見積額を上書きします。本当に実行してもよろしいですか？")) {
      return;
    }

    // TODO: asしなくても通るように型定義したい
    this.estimate = estimateFromProfitRate(
      this.estimate,
      profitRate
    ) as Estimate;
    this.estimate = await service.calculateTotal(this.estimate);
  }

  // APIへ値の保存
  async saveTemplate() {
    // 動作: 保存して一覧に戻る
    this.saving = true;
    if (this.estimate) {
      await this.$store
        .dispatch("estimateTemplate/save", {
          id: this.estimate.id,
          title: this.estimate.title,
          items: this.estimate.items
        })
        .then(() => {
          this.goListPage();
        })
        .catch((e: Error) => {
          alert(e.message);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
}
